import {Component, OnInit} from '@angular/core';
import {SignInFormComponent} from "@app/channels/auth/login/partials/sign-in/partials/sign-in-form/sign-in-form.component";
import {NzTabType} from "ng-zorro-antd/tabs";
import {FormBuilder} from "@angular/forms";
import {AuthenticationService} from "@mpt-fo/common/core/services/authentication.service";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import {LoginHelperService} from "@mpt-fo/common/core/services/login-helper.service";
import {DeviceHelperService} from "@mpt-fo/common/core/services/device-helper.service";
import {ModalService} from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";

@Component({
  selector: 'app-web-sign-in-form',
  templateUrl: './web-sign-in-form.component.html',
  styleUrls: ['./web-sign-in-form.component.scss']
})
export class WebSignInFormComponent extends SignInFormComponent implements OnInit {
  tabType: NzTabType = 'line';
  constructor(
	  fb: FormBuilder,
	  auth: AuthenticationService,
	  profileService: ProfileSetupService,
	  loginHelper: LoginHelperService,
	  deviceHelper: DeviceHelperService,
	  modalService: ModalService) {
	  super(fb, auth, profileService, loginHelper, deviceHelper, modalService);
  }

  ngOnInit(): void {
	  this.buildForm();
  }
}
